export default __webpack_public_path__ + "static/media/BANNER_principalyregistro_scania_volveralfuturo.eb547be4.jpg";